// Single source for the HIU consent list tabs, their counts and the search filter.
import { OTHER_ORGS } from '../../constants/abdmCopy';
import { hiTypeLabel } from '../../constants/abdmHiTypes';
// Tabs are keyed by the backend displayStatus (never recomputed from status/abdmStatus).
export const CONSENT_TABS = [
  { key: 'ALL', label: 'All' },
  { key: 'REQUESTED', label: 'Requested' },
  { key: 'GRANTED', label: 'Granted' },
  { key: 'DENIED', label: 'Denied' },
  { key: 'REVOKED', label: 'Revoked' },
  { key: 'EXPIRED', label: 'Expired' },
  { key: 'SUBMIT_FAILED', label: OTHER_ORGS.notSent },
];

/** @returns {Object<string, number>} count per tab key (incl. ALL) over the given list. */
export function countByDisplayStatus(consents) {
  const counts = Object.fromEntries(CONSENT_TABS.map((t) => [t.key, 0]));
  counts.ALL = consents.length;
  consents.forEach((c) => {
    if (c.displayStatus in counts) counts[c.displayStatus] += 1;
  });
  return counts;
}

/** Case-insensitive match on patient name or full ABHA address. Empty query matches all. */
export function matchesSearch(consent, query) {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return `${consent.patientName || ''} ${consent.patientAbhaAddress || ''}`.toLowerCase().includes(q);
}

// A list row names this many record types, then "+n" for the rest (the detail page lists them all).
export const ROW_TYPES_SHOWN = 2;

/** "OP Consultation, Prescription +6"; '' when there are none (callers show "—"). */
export function typesSummary(hiTypes) {
  const types = hiTypes || [];
  const shown = types.slice(0, ROW_TYPES_SHOWN).map(hiTypeLabel).join(', ');
  const more = types.length - ROW_TYPES_SHOWN;
  return more > 0 ? `${shown} ${OTHER_ORGS.moreTypes(more)}` : shown;
}
